import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import jwt_decode from "jwt-decode";
import { BehaviorSubject, observable, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Permission } from '../../auth/permissions';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class BankPortalAuthService {

  public isLoggedInSubject = new BehaviorSubject<boolean>(false);
  public isLoggedIn$ = this.isLoggedInSubject.asObservable();
  private _user!: User;
  private _merchantInfoKey = '%23IW0';

  constructor(private http: HttpClient,
    private router: Router,
    private _toastr: ToastrService,
    private _cookie: CookieService) {

  }

  login(userName: string, password: string) {
    let loginUrl = `${environment.api_url}/api/users/authenticate`;
    return this.http.post<any>(loginUrl, { UserName: userName, Password: password }, { observe: "response" })
      .subscribe(
        res => {
          localStorage.setItem('token', res.body.token);
          this._user = this.createUserFromToken(res.body.token);
          // this.signalrService.startConnection();
          this.router.navigate(['/home/dashboard/mainDashboard']);
          this._toastr.success("Login Successful", "");
          // push to subscribers of observable
          this.isLoggedInSubject.next(true);
          this.router.navigate(['/home/dashboard/mainDashboard']);
          //  return Observable("User Authenticated")
        },
        (err: HttpErrorResponse) => {
          //  return Observable.throw(err);
          //console.log(err);
          //if (err.status === 401) {
          this._toastr.error("Unauthorized!");
          //}
        });
  }

  decodeToken(): any {
    let rawToken = localStorage.getItem('token');
    if (rawToken != null)
      return jwt_decode(rawToken);
    else
      return null;
  }

  showLoginPageIfTokenExpries(): void {
    if (this.isTokenExpired()){
      this.isLoggedInSubject.next(false); // push to subscribers of observable
      this._cookie.delete(this._merchantInfoKey);
    }
      
    else
      this.isLoggedInSubject.next(true);  // push to subscribers of observable
  }

  public getTokenExpirationDate(): Date {
    let rawToken = localStorage.getItem('token')!;
    const decoded: any = jwt_decode(rawToken);

    // if (decoded.exp === undefined)
    //   return null;

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  public isTokenExpired(): boolean {
    let rawToken = localStorage.getItem('token');
    if (rawToken == null)
    //this._cookie.delete(this._merchantInfoKey);
      return true;

    const date = this.getTokenExpirationDate();
    if (date === undefined) return false;
    return !(date.valueOf() > new Date().valueOf());
  }

  private createUserFromToken(rawToken: string): User {
    let token: any = jwt_decode(rawToken);
    let user = new User();
    user.userName = token.unique_name;
    user.email = token.email;
    user.type = token.usertype;
    user.userId = token.sub;
    user.bankId = token.BankId;

    if (typeof token.role === "string") {
      // user is in only single role
      user.roles = [token.role];
    }
    else {
      user.roles = token.role;
    }

    if (token.permission !== undefined) {
      if (typeof token.permision === "string") {
        user.permissions = [+token.permission as Permission];
      }
      else {
        user.permissions = token.permission.map(x => <Permission>+x);
      }
    }

    return user;
  }

  get user(): User {
    if (this._user)
      return this._user;

    return this.createUserFromToken(localStorage.getItem('token')!);
  }

  public logout(): void {
    localStorage.removeItem('token');
    this.router.navigate(['']);
    //  this.signalrService.disconnect();
    // push to subscribers of observable
    this.isLoggedInSubject.next(false);
    this._cookie.delete(this._merchantInfoKey);
  }

  public hasPermission(permission: Permission): boolean {
    if (this.user.permissions.includes(permission))
      return true;

    return false;
  }
}

export class User {
  userName: string = '';
  fullName: string = '';
  phoneNumber: string = '';
  roles: string[] = [];
  permissions: Array<Permission> = new Array<Permission>;
  email: string = '';
  type: string = '';
  userId: string = '';
  bankId: string = '';
}
